require('/opt/odin/app/frontend/components/questions/banner/index.module.scss');module.exports = "../../app/cells/components/questions/banner/show.erb";